export enum SHARE_SOCIAL_NETWORKS {
    /**
     * @value Due to Twitter terms and conditions, mentions cannot be included in the message.
     * @description Message displayed in the social advocacy views to inform the user that mentions are not supported.
     */
    TWITTER_MENTION_LIMITATION = 'SHARE.TWITTER_MENTION_LIMITATION',
}
